var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-center"},[_c('h1',{staticStyle:{"display":"none"}},[_vm._v("Privacy policy")]),_c('div',{staticClass:"col-12 col-sm-10 col-md-9 q-px-sm"},[_c('Markdown',{staticClass:"privacy-text",attrs:{"data":_vm.md}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }